import React from "react";
import PropTypes from "prop-types";
import { TPRTypeSlug } from "ppt/constants";
import Badge from "@dtci/spellbook/Badge";

const TPRTypeCellRenderer = ({ value }) => {
  const propsMap = {
    [TPRTypeSlug.NATIONAL]: { color: "primary", light: true },
    [TPRTypeSlug.ACCOUNT_SPECIFIC]: { color: "secondary", light: true },
    default: { color: "base", light: true },
  };

  const { color, light } = propsMap[value?.slug] || propsMap.default;
  return (
    <Badge light={light} color={color}>
      {value?.name || "Unknown"}
    </Badge>
  );
};

TPRTypeCellRenderer.propTypes = {
  value: PropTypes.shape({
    slug: PropTypes.string,
    name: PropTypes.string,
  }),
};

export default TPRTypeCellRenderer;
